import { MutationTree } from 'vuex';
import { EFolderMutation, IFoldersState } from './folders.types';
import { IFolder } from '@/folders/types/folder';

export const mutations: MutationTree<IFoldersState> = {
  [EFolderMutation.SetLoading](state: IFoldersState, loading: boolean) {
    state.loading = loading;
  },
  [EFolderMutation.SetLoaded](state: IFoldersState, loaded: boolean) {
    state.loaded = loaded;
  },
  [EFolderMutation.SetFolders](state: IFoldersState, folders: IFolder[]) {
    state.folders = folders.sort((a: IFolder, b: IFolder) => a.name.localeCompare(b.name));
  },
  [EFolderMutation.SetBreadcrumbs](state: IFoldersState, breadcrumbs: IFolder[]) {
    state.breadcrumbs = breadcrumbs;
  },
  [EFolderMutation.SetState](state: IFoldersState, newState: IFoldersState) {
    Object.assign(state, newState);
  },
};
